import type { JSX } from "react";
import { useProfileUpdate } from "./useProfileUpdate";
import PreferencesLayout from "./preferences/PreferencesLayout";

const PreferencesPage = (): JSX.Element => {
  const { fullProfileFormValues, profileReady, ready, submitProfileUpdate } =
    useProfileUpdate();

  return (
    <PreferencesLayout
      profile={fullProfileFormValues}
      profileReady={profileReady}
      ready={ready}
      submitProfileUpdate={submitProfileUpdate}
    />
  );
};

export default PreferencesPage;
